{
  "help": "This setting can only be updated by support.",
  "contact": "Contact support"
}
